<template>
  <div>
    <Card>
      <RadioGroup type="button" v-model="auditingType" id="radioGroup">
        <Radio label="CG">初稿审核
          <Tag color="#ff9900">{{draftListTotal}}</Tag>
        </Radio>
        <Radio label="FS">发售稿审核
          <Tag color="blue">{{sellListTotal}}</Tag>
        </Radio>
      </RadioGroup>
      <span style="margin-left:20px">标题：</span>
      <Input
        style="width:200px;margin-right:20px;"
        type="text"
        v-model="searchValue.WorkflowTitle"
      ></Input>
      <span>创建人：</span>
      <Input
        style="width:150px;margin-right:20px;"
        type="text"
        v-model="searchValue.CreatorRealName"
      ></Input>
      <Button
        type="primary"
        style="margin:5px 10px;"
        @click="handlePage(1)"
      >查询</Button>
      <span style="margin-left: 10%">
        <RadioGroup
          v-model="flowStatus"
          type="button"
          v-show="kind === 'scan'">
          <Radio :label="1">进行中</Radio>
          <Radio :label="2">完成</Radio>
          <Radio :label="3">经办(进行)</Radio>
          <Radio :label="4">经办(完成)</Radio>
        </RadioGroup>
      </span>
    </Card>
    <Card>
      <div v-show="auditingType==='CG'">
        <Table :columns="auditingColumns" :data="draftList">
        </Table>
        <Page style="margin:5px;" :page-size="8" :total="draftListTotal" show-elevator show-total @on-change="handlePage"></Page>
      </div>
      <div v-show="auditingType==='FS'">
        <Table :columns="auditingColumns" :data="sellList">
        </Table>
        <Page style="margin:5px;" :page-size="8" :total="sellListTotal" show-elevator show-total @on-change="handlePage"></Page>
      </div>
    </Card>
    <Modal :title="this.kind === 'todo' ? '审核文件' : '项目信息'" v-model="fileVisible" width="700">
      <Button size="small" type="primary" style="margin-bottom:5px;" @click="auditingFileSelect">上传修改文件</Button>
      <input type="file" ref="auditingFile" style="display:none" @change="auditingFileUpload">
      <Table :columns="fileColumns" :data="fileList"></Table>
    </Modal>
    <Modal title="审核人员选择" v-model="examineVisible" width="700px" :mask-closable="false">
      <peopleSelect :child-msg="selectPropleList" @toparentevent="handlePeopleSelect"></peopleSelect>
      <div slot="footer" class="dialog-footer">
        <Button>取消</Button>
        <Button type="primary" @click="nextFlow">确定</Button>
      </div>
    </Modal>
    <Modal title="退回原因" v-model="opinionVisible">
      <Input v-model="rejectOpinion"></Input>
      <div slot="footer">
        <Button @click="opinionVisible=false">取消</Button>
        <Button @click="rejectFlowConfirm" type="primary">确定</Button>
      </div>
    </Modal>
    <Modal title="备注" v-model="commentVisible">
      <Input v-model="nextOpinion" placeholder="可不填"></Input>
      <div slot="footer">
        <Button @click="commentVisible=false">取消</Button>
        <Button @click="nextFlowConfirm" type="primary">确定</Button>
      </div>
    </Modal>
    <Modal v-model="flowHistoryVisible" title="流程详情" width="800">
      <flowHistory :flowDetailHistory="flowDetailHistory"></flowHistory>
      <div slot="footer"></div>
    </Modal>
  </div>
</template>

<script>
import { getActivityUsers, getToDoList, endFlow, getRejectActivityUsers, rejectFlow, deliverFlow, getFlowHistory, getMyWorkItem, getGetDoneList  } from '@/lib/flow'
import axios from 'axios'
import peopleSelect from '@/components/workflow/peopleSelect'
import ajax from '@/lib/ajax'
import requestUrls from '@/lib/requestUrls'
import sendMessage from '@/lib/message'
import { formatDate } from '@/lib/tool';
import FlowHistory from '@/components/flow/flowHistory'
import localFile from '@/lib/localFile'

export default {
  props: {
		kind: String
	},
  components: {
    peopleSelect,
    FlowHistory
  },
  data() {
    return {
      flowHistoryVisible: false,
      flowDetailHistory: [],
      auditingType: 'CG',
      draftListTotal: 0,
      sellListTotal: 0,
      auditingColumns: [
        {
          width: 100,
          title: '状态',
          render: (h, params) => {
            if (params.row.WorkflowInstanceState === 2) {
              return h('Button', {
                props: {
                  type: 'success',
                  size: 'small'
                },
              }, '待办')
            } else if (params.row.WorkflowInstanceState === 5) {
              return h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
              }, '驳回')
            }
          }
        },
        {
          title: '项目名称',
          key: 'WorkflowTitle'
        },
        {
          title: '创建人',
          key: 'FromCreator',
          render: (h,params) => {
            return h('div', params.row.CreatorRealName ? params.row.CreatorRealName : '/')
          }
        },
        {
          title: '创建时间',
          width: 180,
          render: (h, params) => {
            let time = new Date(parseInt(params.row.CreatedTime.slice(6, 19))).toLocaleString().replace(/\//g, '-')
            return h('span', time);
          }
        },
        {
          title: '操作',
          width: 280,
          align: 'center',
          render: (h, params) => {
            let disArr = [true, true, true]
            if (params.row.WorkflowInstanceState === 2) {
              disArr = [false, false, false]
            }
            if (params.row.WorkflowInstanceState === 5) {
              disArr = [false, false, true]
            }
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: disArr[0]
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.viewAuditingFiles(params.row)
                  }
                }
              }, this.kind === 'todo' ? '审核文件' : this.kind === 'scan' ? '项目信息' : '审核文件'),
              h('Button', {
                props: {
                  type: 'success',
                  size: 'small',
                  disabled: disArr[1]
                },
                style: {
                  marginRight: '5px',
                  display: this.kind === 'todo' ? '' : this.kind === 'scan' ? 'none' : ''
                },
                on: {
                  click: () => {
                    // this.selectUser(params.row)
                    this.selectExamine = params.row
                    this.commentVisible = true
                  }
                }
              }, '通过'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                  disabled: disArr[2]
                },
                style: {
                  marginRight: '5px',
                  display: this.kind === 'todo' ? '' : this.kind === 'scan' ? 'none' : ''
                },
                on: {
                  click: () => {
                    this.getRejectNode(params.row)
                  }
                }
              }, '退回'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                on: {
                  click: async () => {
                    this.flowHistoryVisible = true
                    let rep = await getFlowHistory(this.userPhone, params.row.WorkflowInstanceId)
                    this.flowDetailHistory = rep
                  }
                }
              }, '流程详情'),
            ])
          }
        }
      ],
      selectExamine: '',
      draftList: [],
      sellList: [],
      // userPhone: '',
      // username: '',
      fileList: [],
      fileVisible: false,
      fileColumns: [
        {
          title: '文件名称',
          key: 'fileName'
        },
        {
          title: '上传人员',
          key: 'uploadPerson',
          width: 90
        },
        {
          title: '上传时间',
          width: 170,
          render: (h, params) => {
            // let time = new Date(params.row.uploadTime)
            // time = time.toLocaleString().replace(/\//g, '-')
            // return h('span', time)
            if (params.row.uploadTime) {
              return h('span', params.row.uploadTime.split('.')[0].replace('T', ' '))
            }
            return ''
          }
        },
        {
          title: '操作',
          width: 80,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  size: 'small',
                  type: 'primary'
                },
                on: {
                  click: () => {
                    this.downloadFile(params.row)
                  }
                }
              }, '查看')
            ])
          }
        }
      ],
      projectId: '',
      selectPropleList: [],
      examineVisible: false,
      selectedPeople: '',
      selectFlow: '',
      cgCurrentPage: 1,
      fsCurrentPage: 1,
      rejectNode: '',
      opinionVisible: false,
      rejectOpinion: '',
      messageParams: {
        appId: '1005',
        uniqueId: '',
        contentJson: {
          title: '审核',
          subTitle: '消息',
          description: '项目文件等待审核',
          url: 'http://qy.chinapsp.cn:8884?qyLogin#/userCenter/auditingFile'
        }
      },
      commentVisible: false,
      nextOpinion: '',
      searchValue: {
        WorkflowTitle: '',
        CreatorRealName: '',
      },
      flowStatus: 0
    }
  },
  async mounted() {
		// 侧边栏项目立项
		if (this.kind) {
      this.auditingColumns = this.auditingColumns.filter(item => item.title !== '状态')
        this.flowStatus = this.kind === 'scan' ? 1 : 0
		}
    this.getWorkList('CG', 1)
    this.getWorkList('FS', 1)
  },
  computed: {
    username () {
      return this.$store.state.session.user.name
    },
    userPhone () {
      return this.$store.state.session.user.phoneNumber
    }
  },
  watch: {
    flowStatus(status) {
      this.getWorkList(this.auditingType, 1)
    },
    kind(val) {
      this.flowStatus = val === 'scan' ? 1 : 0
      this.getWorkList(this.auditingType, 1)
    }
  },
  methods: {
    nextFlowConfirm() {
      this.selectUser(this.selectExamine)
      this.commentVisible = false
    },
    handlePage(page) {
      this.getWorkList(this.auditingType, page)
    },
    async getWorkList(type, page) {
      if (type === 'CG') {
        this.cgCurrentPage = page
      }
      if (type === 'FS') {
        this.fsCurrentPage = page
      }
      let rep = {}
      switch (this.flowStatus) {
        case 0:
          rep = await getToDoList(this.userPhone, { page: page, whereStr: `AppId='${type}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`})
          break
        case 1:
          rep = await getMyWorkItem(this.userPhone, { page: page, whereStr: `AppId='${type}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`, isHistory: 0 })
          break
        case 2:
          rep = await getMyWorkItem(this.userPhone, { page: page, whereStr: `AppId='${type}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`, isHistory: 1 })
          break
        case 3:
          rep = await getGetDoneList(this.userPhone, { page: page, whereStr: `AppId='${type}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`, isHistory: 0 })
          break
        case 4:
          rep = await getGetDoneList(this.userPhone, { page: page, whereStr: `AppId='${type}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and CreatorRealName like'%${this.searchValue.CreatorRealName}%'`, isHistory: 1 })
          break
      }
      // let params = {
      //   page: page,
      //   // whereStr: `AppId='${type}'`
      //   whereStr: `AppId='${type}' and WorkflowTitle like'%${this.searchValue.WorkflowTitle}%' and FromCreator like'%${this.searchValue.CreatorRealName}%'`
      // }
      // getToDoList(this.userPhone, params).then(
      //   res => {
          if (type === 'CG') {
            this.draftList = rep.rows
            this.draftListTotal = rep.total
          }
          if (type === 'FS') {
            this.sellList = rep.rows
            this.sellListTotal = rep.total
          }
          this.$store.commit('fileCount', this.draftListTotal + this.sellListTotal)
      //   }
      // )
    },
    async viewAuditingFiles(row) {
      let fl = ''
      if (this.auditingType === 'CG') {
        fl = 2
      }
      if (this.auditingType === 'FS') {
        fl = 32
      }
      // 查询文件列表
      this.$Spin.show()
      // let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${row.BusinessKey}&fl=${fl}`)

      const params = {
        filter: `fileTypeId=="${fl}" and projectId=="${row.BusinessKey}"`
      }
      let rep = await ajax.get(requestUrls.clfile.getList, { params })

      this.fileList = rep.data.result
      this.projectId = row.BusinessKey
      this.fileVisible = true
      this.$Spin.hide()
    },
    async downloadFile(file) {
      // window.open(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/downFile?id=${file.id}&name=${this.username}`)
      // const blobUrl = await localFile.downLoadBlob(file.fileGuid)
      // localFile.currentLoad(blobUrl, file.fileName)
      localFile.directLoadFile(file.fileGuid, file.fileName, file.fileSuffix)
    },
    auditingFileSelect() {
      this.$refs.auditingFile.click()
    },
    async auditingFileUpload() {
      this.$Spin.show()
      try {
        // 添加流程ID给文件
        let flowId = ''
        let fl = ''
        let fileclass = ''
        if (this.fileList.length > 0) {
          flowId = this.fileList[0]['fileGuid']
          if (this.fileList[0]['flowId']) {
            flowId = this.fileList[0]['flowId']
          }
        }
        if (this.auditingType === 'CG') {
          fl = 2
          fileclass = '审查过程文件'
        }
        if (this.auditingType === 'FS') {
          fl = 32
          fileclass = '招标文件发售稿'
        }


        // let formData = new FormData()
        // formData.append('fileToUpload', this.$refs.auditingFile.files[0])
        // formData.append('username', this.username)
        // formData.append('fl', fl)
        // formData.append('fileclass', fileclass)
        // formData.append('npid', this.projectId)
        // formData.append('wiid', flowId)
        // let rep = await axios.post('http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpUpload', formData)

        // 上传文件
        let fileRep = await localFile.uploadFile(this.$refs.auditingFile.files[0])

        if (!fileRep) {
          throw 'uploadError'
        }

        // 提交记录
        const params = {
          projectId: this.projectId,
          fileName: fileRep.fileName,
          fileGuid: fileRep.serviceGuid,
          fileSuffix: fileRep.extension,
          fileTypeId: fl,
          uploadPerson: this.username,
          fileTypeName: fileclass,
          flowId: flowId
        }
        let recordRep = await localFile.createFileRecord(params)

        if (!recordRep) {
          throw 'RecordError'
        }

        this.$Spin.hide()
        this.$refs.auditingFile.value = ''

        this.$Message.success('上传成功')

        // 刷新当前文件列表
        // let rep = await axios.post(`http://oa.chinapsp.cn:8088/FileModule/Gdfile/AbpGetFileList?npid=${this.projectId}&fl=${fl}`)
        const getParams = {
          filter: `fileTypeId=="${fl}" and projectId=="${this.projectId}"`
        }
        let rep = await ajax.get(requestUrls.clfile.getList, { params: getParams })

        this.fileList = rep.data.result

      } catch (err) {
        this.$refs.auditingFile.value = ''
        this.$Spin.hide()
        this.$Message.error('上传失败')
      }
    },
    selectUser(row) {
      this.selectFlow = row
      // 清空选择人员
      this.selectedPeople = ''
      this.$Spin.show()
      getActivityUsers({ appId: this.auditingType, userPhone: this.userPhone, taskId: row.TaskId }).then(
        res => {
          this.$Spin.hide()
          this.selectPropleList = res[0]
          this.examineVisible = true
        },
        err => {
          this.$Spin.hide()
          console.error(err)
          this.$Message.error('获取人员失败')
        }
      )
    },
    handlePeopleSelect(selectedPeople) {
      this.selectedPeople = selectedPeople
    },
    nextFlow() {
      this.$Spin.show()
      // 结束流程
      if (this.selectPropleList.NextActivityName === '结束') {
        // 发售稿结束设定项目状态
        // if (this.auditingType === 'FS') {
          ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
            id: this.selectFlow.BusinessKey,
            projectState: this.auditingType === 'FS' ? '审查通过可挂网' : '标书文件已完成'
          }).then(() => {
            if (this.auditingType === 'CG') {
              // ajax.put(requestUrls.ClProjectDb.UpdateStatus, {
              //   id: this.selectFlow.BusinessKey,
              //   projectState: '标书文件已完成'
              // })
              ajax.post(requestUrls.ClProjectDb.ProjectTime, {
                id: this.selectFlow.BusinessKey,
                sendTime: formatDate()
              })
            }
            endFlow(this.userPhone, { taskId: this.selectFlow.TaskId, nextActivityCode: this.selectPropleList.NextActivityCode, opinion: this.nextOpinion }).then(
              async res => {
                this.$Spin.hide()
                this.$Message.success('通过成功')
                this.nextOpinion = ''
                this.examineVisible = false
                this.refreshFlowList()
    
                // 获取历史信息
                getFlowHistory(this.userPhone, this.selectFlow.WorkflowInstanceId).then(
                  res => {
                    let toUser = res[0].RealName
                    // 发送结束流程信息
                    this.messageParams.contentJson.title = this.selectFlow.WorkflowTitle
                    this.messageParams.contentJson.subTitle = '审核文件结束'
                    this.messageParams.contentJson.description = '项目文件审核已通过'
                    this.messageParams.uniqueId = toUser
                    sendMessage('wechat', this.messageParams)
                  },
                  err => {
                    console.error(err)
                  }
                )
    
              },
              err => {
                console.error(err)
                this.$Spin.hide()
                this.$Message.error('通过失败')
              }
            )
          })
      } else {
        if (this.selectedPeople == '') {
          this.$Spin.hide()
          this.$Message.error('请选择流程人员')
          return
        }
        // 转交流程
        deliverFlow(this.userPhone, { taskId: this.selectFlow.TaskId, nextActivityCode: this.selectPropleList.NextActivityCode, userId: this.selectedPeople.userId, opinion: this.nextOpinion }).then(
          res => {
            this.$Spin.hide()
            this.$Message.success('通过成功')
            this.nextOpinion = ''
            this.examineVisible = false
            this.refreshFlowList()

            // 发送转交审核信息
            this.messageParams.contentJson.title = this.selectFlow.WorkflowTitle
            this.messageParams.contentJson.subTitle = '审核文件'
            this.messageParams.contentJson.description = '项目文件等待审核'
            this.messageParams.uniqueId = this.selectedPeople.userName
            sendMessage('wechat', this.messageParams)

          },
          err => {
            this.$Spin.hide()
            this.$Message.error('通过失败')
          }
        )
      }
      // }
    },
    getRejectNode(row) {
      this.selectFlow = row
      this.$Spin.show()
      // 获取驳回节点人员
      getRejectActivityUsers(this.userPhone, row.TaskId).then(
        res => {
          this.$Spin.hide()
          // 记录驳回节点
          this.rejectNode = res[res.length - 1]
          this.opinionVisible = true
        },
        err => {
          console.error(err)
          this.$Spin.hide()
          this.$Message.error('无法退回')
        }
      )
    },
    rejectFlowConfirm() {
      if (this.rejectOpinion == '') {
        this.$Message.error('请输入退回原因')
        return
      }
      this.$Spin.show()
      rejectFlow(this.userPhone, { taskId: this.selectFlow.TaskId, activityCode: this.rejectNode.ActivityCode, opinion: this.rejectOpinion }).then(
        res => {
          this.$Spin.hide()
          this.opinionVisible = false
          this.$Message.success('退回成功')
          this.refreshFlowList()

          // 获取历史信息
          getFlowHistory(this.userPhone, this.selectFlow.WorkflowInstanceId).then(
            async res => {
              let toUser = res[res.length - 1].RealName
              // 发送退回消息
              this.messageParams.contentJson.title = this.selectFlow.WorkflowTitle
              this.messageParams.contentJson.subTitle = '审核文件退回'
              this.messageParams.contentJson.description = '审核文件被退回：' + this.rejectOpinion
              this.messageParams.uniqueId = toUser
              await sendMessage('wechat', this.messageParams)

              this.rejectOpinion = ''
            },
            err => {
              console.error(err)
            }
          )

        },
        err => {
          this.$Spin.hide()
          this.$Message.error('退回失败')
        }
      )
    },
    refreshFlowList() {
      // 刷新列表
      let page = 1
      if (this.auditingType === 'CG') {
        page = this.cgCurrentPage
      }
      if (this.auditingType === 'FS') {
        page = this.fsCurrentPage
      }
      this.getWorkList(this.auditingType, page)
    }
  }
}
</script>
